import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
// import { RootState } from './profile/profile-types';
import { domain } from './domain/index';
import { profile } from './profile/index';
import { industry } from './industry/index';
import { functions } from './functions/index';
import { digital } from './digital/index';
import { professional } from './professional/index';
import { idealProfile } from './idealProfile/index';

Vue.use(Vuex);

export interface RootState {
  version: string;
  showExtraOption: boolean;
}

const store: StoreOptions<RootState> = {
  state: { version: '1.0.0', showExtraOption: false },
  modules: {
    domain,
    profile,
    functions,
    industry,
    digital,
    professional,
    idealProfile,
  },
};
export default new Vuex.Store<RootState>(store);
